<template>
  <div>
    <div class="real-project">
      <div class="title">
        <div>{{realProjectCom.title}}</div>
        <p>
          <em>{{realProjectCom.mainNum}}</em>&nbsp;&nbsp;
          <span>{{realProjectCom.main}}</span>&nbsp;&nbsp;
          <em>{{realProjectCom.coreNum}}</em>&nbsp;&nbsp;
          <span>{{realProjectCom.core}}</span>
        </p>
      </div>
      <div class="list">
        <div class="item-parent">
          <div style="padding-left: 10px; padding-right: 10px;"
            v-for="value in itemData"
            :key="value.id"
            class="item-child"
          >
            <div @click="goDetails(value)" v-track="[ value.name, '点击图标' ]">
              <div class="divImg">
                <img src="@/assets/cover.jpg" v-if="!value.logoImage" />
                <img v-lazy="{ src: value.logoImage.url, loading: require('@/assets/coverpic.jpg') }" v-else />
              </div>
              <div class="textInfo" style="display:flex;justify-content: space-between;color:#19232B;">
                <div>
                  <span v-if="value.trade !== null">
                    <span class="fontBg" :style="{ background: '#ebeff5', color: '#333' }"
                      v-if="value.trade.color === null || value.trade.color == ''">{{ value.trade.name }}</span>
                    <span class="fontBg" :style="{ color: value.trade.color, }" v-else>{{ value.trade.name }}</span>
                  </span>
                  {{ value.name }}
                </div>
                <div>
                  <!-- <div v-if="value.productImages1 && value.productImages1.length > 0">{{value.productImages1[0].url}}</div> -->
                   <img v-if="value.productImages1 && value.productImages1.length > 0" style="display: block;padding-top: 7px;" :src="value.productImages1[0].url" width="56" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <p>
          <em style="margin-right:10px;">—</em>
          <span>
            <span style="opacity: .6;">所&nbsp;&nbsp;有&nbsp;&nbsp;项&nbsp;&nbsp;目&nbsp;&nbsp;采&nbsp;&nbsp;
              <span style="margin-right: 10px;">取</span>
            </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span style="color:#fff;font-weight: 900;">教&nbsp;&nbsp;学 + 授&nbsp;&nbsp;
              <span style="margin-right:10px;">课</span>
            </span>
              <span style="opacity: .6;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;的&nbsp;&nbsp;方&nbsp;&nbsp;式&nbsp;&nbsp;全&nbsp;&nbsp;部&nbsp;&nbsp;提&nbsp;&nbsp;供&nbsp;&nbsp;给&nbsp;&nbsp;学&nbsp;&nbsp;员&nbsp;&nbsp;</span>
            </span>
          <em style="margin-left:10px;">—</em>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Contents } from "../../../../../gqlapi/Contents.js"
window.addEventListener('beforeunload', () => {
  window.scroll(0, 0)
})
export default {
  props: {
    realProjectCom: {
      readonly: true,
      require: true,
      default: () => {}
    }
  },
  data () {
    return {
      classObject: {

      },
      itemData: []
    }
  },
  created () {
    this.getList("7")
  },
  methods: {
    goDetails (value) {
      // this.$trackEvent(value.name, '点击图标', value.name)
      window.sessionStorage.setItem("detailsId", String(value.id))
      let routerData
      if (value.router) {
        routerData = this.$router.resolve({
          path: value.router,
        });
      } else if (value.p_template && value.p_template.code) {
        routerData = this.$router.resolve({
          path: "/" + value.p_template.code
        })
      } else {
        routerData = this.$router.resolve({
          path: "/details"
        })
      }
      window.open(routerData.href, "_blank")
    },
    getList (ids) {
      // this.$apollo.query({
      //     query: Contents,
      //     variables: {
      //       subjectID: ids,
      //       isPublish: true
      //     }
      //   })
        this.$axios.post('/api',{
            operationName: "Contents",
            variables:{
              subjectID: ids,
              isPublish: true
            },
            query: Contents
        }).then((res) => {
          console.log(322, res.data.data.pContents)
          this.itemData = res.data.data.pContents
          
          // this.itemData.forEach(item => {
          //   if (item.productImages1 && item.productImages1.length > 0){
          //     this.itemData.productImages = item.productImages1[0].url
          //   }
          //   console.log(322111, this.itemData.productImages)
          // });
          const isIdsObj = {
            "11": "black",
            "9": "suyun",
            "6": "zhiwei",
            "13": "zhiniugu",
            "17": "saas",
            "19": "ihrm",
            "15": "likede",
            "20": "money",
            "5": "health",
            "8": "ice",
            "22": "zhihui",
            "21": "juhe",
            "1": "buy",
            "3": "chong"
          }
          this.itemData = this.itemData.map((obj) => ({ ...obj, src: isIdsObj[obj.id] }))
        })
        .catch(() => {
        })
    }
  },
}
</script>

<style lang="scss" scoped>
  .real-project {
    width: 100%;
    height: auto;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    padding-top: 76px;
    background-color: #ECF0F5;
    .title {
      margin: 0 auto;
      text-align: center;
      position: relative;
      height: 39px;
      color: #19232B;
      font-size: 18px;
      div {
          font-size: 32px;
          font-family: PingFangSC;
          font-weight: 600;
          text-align: center;
          color: #19232b;
          line-height: 45px;
          z-index: 2;
      }
      p { 
          font-size: 16px;
          font-family: PingFangSC;
          text-align: center;
          line-height: 70px;
          font-weight: 400;
          z-index: 2;
          margin-bottom: 14px;
          color: #616a72;
        em {
          display: inline-block;
          padding:0 5px;
          box-sizing: border-box;
          height: 21px;
          border-radius: 4px;
          background-color: #FF743C;
          line-height: 21px;
          color: #fff;
        }
        span {
          display: inline-block;
          height: 28px;
          line-height: 28px;
          
        }
      }
    }
    .list {
      max-width: 1200px;
      min-width: 1200px;
      margin: 0 auto;
      margin-top: 76px;
      overflow: hidden;
      padding-top: 10px;
      .item-parent {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;
        .item-child {
          width: 361px;
          height: 203px;
          padding: 10px;
          padding-bottom: 20px;
          padding-right: 20px;
          margin-bottom: 30px;
          border: 0 solid #dcdee3;
          border-radius: 5px;
          box-shadow: 0 2px 14px 0 rgba(0, 0, 0, .1);
          background: #fff;
          transition: all 0.5s;
          cursor: pointer;
          .divImg {
            text-align: center;
            img {
              width: 361px;
              height: 170px;
            }
          }
          p {
              margin-top: -7px;
              font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
          }
          &:hover {
              transform: scale(1.03);
          }
          }
        }
      .item-parent:after {
        content: '';
        width: 32%;
      }
    }
    .footer {
      display: inline-block;
      margin: 40px auto;
      position: relative;
      left: 50%;
      transform: translate(-50%); 
      padding: 0 80px;
      line-height: 40px;
      background-image: linear-gradient(to right, #FF743C, #FF4F4F);
      border-radius: 20px;
      font-size: 16px;
      color: #fff;
      p {
        text-align: center;
        font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
        em {
          display: inline-block;
        }
      }
    }
  }
</style>